import { GET_DYNAMIC_DROPDOWN_FROM_CONFIG } from "../actions/projectDetailAction";
import _ from "lodash";
import {
  SALE_TYPE,
  MODEL_TYPES,
  ROLE_TYPES,
  STAGE,
  EDUCATION_LIST,
  TARGET_AUDIENCE,
  TRAVEL_OFTEN,
  TYPE_OF_CONTENT,
  TYPE_OF_PAYOUT,
} from "../constants/CRMConstants";

const initialState = {
  crmDetails: {},
  projectDetails: {},
  roles: [],
  domains: [],
  skills: [],
  languages: [],
  stageDropdown: [],
  educationDropdown: [],
  saleTypeDropdown: [],
  contentTypeDropdown: [],
  targetAudienceDropdown: [],
  modelTypeDropdown: [],
  howOftenTravellingDropdown: [],
  roleTypeDropdown: [],
};

const getDropdownValues = (payload, key, fallback) => {
  const dropdown = _.find(payload, { key });

  return dropdown?.values?.length > 0 ? dropdown.values : fallback;
};

const projectDetailsReducer = (state = initialState, action) => {
  if (action.type === GET_DYNAMIC_DROPDOWN_FROM_CONFIG) {
    return {
      ...state,
      stageDropdown: STAGE,
      educationDropdown: getDropdownValues(
        action.payload,
        "education",
        EDUCATION_LIST
      ),
      saleTypeDropdown: getDropdownValues(
        action.payload,
        "sale_type",
        SALE_TYPE
      ),
      contentTypeDropdown: getDropdownValues(
        action.payload,
        "content_type",
        TYPE_OF_CONTENT
      ),
      targetAudienceDropdown: getDropdownValues(
        action.payload,
        "target_audience",
        TARGET_AUDIENCE
      ),
      modelTypeDropdown: getDropdownValues(
        action.payload,
        "model_type",
        MODEL_TYPES
      ),
      howOftenTravellingDropdown: TRAVEL_OFTEN,
      roleTypeDropdown: getDropdownValues(
        action.payload,
        "role_type",
        ROLE_TYPES
      ),
      typeOfPayout: getDropdownValues(
        action.payload,
        "type_of_payout",
        TYPE_OF_PAYOUT
      ),
    };
  }

  return state;
};

export default projectDetailsReducer;
